import React, { useEffect, useState } from "react";
import "../Folder.css";
import "../SildeCopy.css";
import {
  Col,
  Row,
  Button,
  Input,
  Drawer,
  Form,
  Checkbox,
  Flex,
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  RiSearch2Line,
  RiMore2Fill,
  RiBookOpenFill,
  RiTerminalBoxFill,
  RiFileList2Fill,
} from "react-icons/ri";
import { workspaces_List_ActionHandler } from "../../../../../Redux/Actions/user/WorkspacesList";
import { workspaces_FolderList_ActionHandler } from "../../../../../Redux/Actions/user/WorkspaceFolderList";
import {
  QuickActionCopyHandler,
  Quick_Action_Copy_Success,
} from "../../../../../Redux/Actions/user/QuickCopyAction";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;
const { Option } = Select;

const CopySave = ({ StandardOverlay, isStandardOpen, selectedCopyItem }) => {
  let dispatch = useDispatch();
  let Navigate = useNavigate();
  const SideClose = "/assets/ModalClose.svg";
  const [workspaceId, setWorkspaceId] = useState(null);
  const formRef = React.createRef();
  const workspaceData = useSelector(
    (state) => state?.workspaces_List_Data?.workspace_create_data?.data
  );

  const [filteredWorkspaces, setFilteredWorkspace] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);

  useEffect(() => {
    let newFilteredWorkspaces = [];
    if (
      workspaceData != undefined &&
      workspaceData != null &&
      workspaceData != "" &&
      Object.keys(workspaceData).length > 0
    ) {
      newFilteredWorkspaces = workspaceData.filter(
        (workspaceData) => workspaceData.is_locked != true
      );
    }
    setFilteredWorkspace(newFilteredWorkspaces);
  }, [workspaceData]);

  const workspaceFolderListData = useSelector(
    (state) =>
      state?.workspaces_FolderList_Data?.workspace_folderList_data?.data
  );
  const quickActionCopyData = useSelector(
    (state) => state?.QuickActionCopyData?.quick_action_copy_data?.data
  );

  useEffect(() => {
    if (quickActionCopyData?.id) {
      dispatch(Quick_Action_Copy_Success(null));
      StandardOverlay();
    }
  }, [quickActionCopyData]);

  useEffect(() => {
    dispatch(workspaces_List_ActionHandler("", ""));
  }, []);
  const handleChangeWorkspace = (value, event) => {
    formRef.current.resetFields(["folder_id"]);
    setWorkspaceId(value);
    setSelectedWorkspace(event.workspace_name);
  };

  const renderSupportingUploadedDoc = (data) => {
    return data.map((item, index) => {
      return (
        <Col span={24} key={`support-upload-doc-${item.id}-${index}`}>
          <Flex gap="middle" vertical>
            <Flex justify="space-around" align="center">
              <div className="copy-save-width-12 copy-save-height-54">
                <RiBookOpenFill className="copy-save-sideIcon-size" />
              </div>
              <div className="copy-save-width-78 copy-save-height-54">
                <span> {item.name}</span>
              </div>
              {/* <div className='copy-save-width-5 copy-save-height-54'>
                                                    <div className='copy-save-text'>
                                                        <Checkbox value='A'></Checkbox>
                                                    </div>
                                                </div>
                                                <div className='copy-save-width-5 copy-save-height-54'>
                                                    <RiMore2Fill className='copy-save-sideIcon-size' />
                                                </div> */}
            </Flex>
          </Flex>
        </Col>
      );
    });
  };

  useEffect(() => {
    if (workspaceId) {
      dispatch(workspaces_FolderList_ActionHandler(workspaceId, "", ""));
    }
  }, [workspaceId]);
  const onFinish = (values) => {
    const submitObject = {
      workspace_id: parseInt(values.workspace_id, 10),
      folder_id: parseInt(values.folder_id, 10),
      name: values.name,
      isQaid: selectedCopyItem.id,
      workspace_name: selectedWorkspace,
    };
    dispatch(QuickActionCopyHandler(submitObject, Navigate));
  };
  return (
    <>
      <Drawer
        placement="right"
        closable={false}
        onClose={StandardOverlay}
        open={isStandardOpen}
        key="right"
        width={"50%"}
      >
        <Form
          name="uploadComputerForm"
          initialValues={{
            name: selectedCopyItem?.name,
            workspace_id: "",
            foler_id: "",
          }}
          ref={formRef}
          onFinish={onFinish}
        >
          <div className="copy-save-container">
            <div className="copy-save-main_1">
              <div className="copy-save-build-main">
                <h2>Copy and Save</h2>
                <p className="copy-save-p copy-save-w copy-save-pointer">
                  <img src={SideClose} alt="" onClick={StandardOverlay} />
                </p>
              </div>
              <p className="copy-save-label">QuickAction Name</p>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input your QuickAction Name!",
                  },
                  {
                    type: "name",
                    message: "Please enter a valid QuickAction Name",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your QuickAction Name"
                  // disabled
                />
              </Form.Item>
              {/* <p className="copy-save-label">Description (not required)</p>
            <Form.Item
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please input your Description!",
                },
              ]}
            >
              <Input placeholder="Enter your Description" />
            </Form.Item> */}
            </div>
            {/* <div className="separator-copy-save"></div> */}
            {selectedCopyItem.is_restricted ||
            selectedCopyItem.custom_qa_v_id !== null ? (
              <div></div>
            ) : (
              <>
                <div className="copy-save-refer-data">
                  <RiFileList2Fill className="copy-save-sideIcon-size" />
                  <p className="copy-save-p copy-save-w copy-save-ml-5">
                    Reference data
                  </p>
                </div>
                <div className="copy-save-main_2">
                  <div className="copy-save-tabel">
                    <Row>
                      <Col span={24}>
                        <div>
                          <p className="copy-save-p copy-save-w">
                            Supporting Documents
                          </p>
                          <p className="copy-save-label">
                            This data will support and inform the output of your
                            Quick Action
                          </p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <p className="copy-save-p">Uploaded Documents</p>
                      </Col>
                      {selectedCopyItem?.supporting_docs?.length ? (
                        renderSupportingUploadedDoc(
                          selectedCopyItem.supporting_docs
                        )
                      ) : (
                        <div>- No Doucument Available</div>
                      )}
                    </Row>
                  </div>
                  <div className="copy-save-availibility">
                    <div className="copy-save-aval-inner">
                      <Row>
                        <Col span={24}>
                          <div>
                            <p className="copy-save-p copy-save-w">
                              Output Format
                            </p>
                            <p className="copy-save-label">
                              This represents your desired output format,
                              ensuring output consistency.
                            </p>
                          </div>
                        </Col>
                        <Col span={24}>
                          <p className="copy-save-p">Uploaded Documents</p>
                        </Col>
                        {selectedCopyItem?.op_formats?.length ? (
                          renderSupportingUploadedDoc(
                            selectedCopyItem.op_formats
                          )
                        ) : (
                          <div>- No Doucument Available</div>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
                <div className="copy-save-mb-24">
                  <div className="copy-save-main_1">
                    <div className="copy-save-main-sub-title">
                      <RiTerminalBoxFill className="copy-save-sideIcon-size" />
                      <p className="copy-save-p copy-save-w copy-save-ml-5">
                        QuickAction Prompt
                      </p>
                    </div>
                    <div className="">
                      <p className="copy-save-label">
                        Compose your QuickAction here.
                      </p>
                      <TextArea
                        rows={4}
                        value={selectedCopyItem?.prompt}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="copy-save-main_1">
              <div className="copy-save-main-sub-title">
                <RiFileList2Fill className="copy-save-sideIcon-size" />
                <p className="copy-save-p copy-save-w copy-save-ml-5">
                  Select Destination Workspace
                </p>
              </div>
              <div className="">
                <p className="copy-save-label">Select Workspace</p>
                <div className="copy-save-search-div">
                  <Form.Item
                    name="workspace_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a workspace!",
                      },
                    ]}
                  >
                    <Select
                      className="uploadcomputer-select"
                      onChange={handleChangeWorkspace}
                    >
                      {filteredWorkspaces &&
                        filteredWorkspaces.map((workspace) => (
                          <Option
                            key={workspace.id}
                            value={workspace.id}
                            workspace_name={workspace.name}
                          >
                            {workspace.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </div>

                <p className="copy-save-label">Select Folder</p>
                <div className="copy-save-search-div">
                  <Form.Item
                    name="folder_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a folder!",
                      },
                    ]}
                  >
                    <Select className="uploadcomputer-select" name="folder_id">
                      {workspaceFolderListData &&
                        workspaceFolderListData.map((folder) => (
                          <Option key={folder.id} value={folder.id}>
                            {folder.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="copy-save-action-button">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  className="main-copy-save-button"
                >
                  Copy and Save
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Drawer>
    </>
  );
};
export default CopySave;
